<template>
    <div class="fl-range-slider">
        <!-- Vuetify's Range Slider does not support v-model so manually pass :value and subscribe @end. -->
        <v-range-slider
            v-model="currentRange"
            @end="onRangeSliderChange"
            :min="filter.totalRange.min"
            :max="filter.totalRange.max"
            :step="filter.stepSize"
            hide-details
        />
        <div class="d-flex">
            <v-row>
                <!-- @input or v-model will update the results on every keystroke. Using @change to update only on blur. -->
                <v-col>
                    <v-text-field
                        class="slider-input"
                        dense
                        outlined
                        hide-details
                        :value="formatNumber(currentRange[0])"
                        @change="onRangeSliderChange([$event, filter.selectedRange.max])"
                        :prefix="currencySymbol"
                        aria-label="minimum"
                    />
                </v-col>
                <v-col class="shrink"> - </v-col>
                <v-col>
                    <v-text-field
                        class="slider-input"
                        dense
                        outlined
                        hide-details
                        :value="formatNumber(currentRange[1])"
                        @change="onRangeSliderChange([filter.selectedRange.min, $event])"
                        :prefix="currencySymbol"
                        aria-label="maximum"
                    />
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script lang="ts">
import { Filter } from '../../../../../declarations/result';
import { PropType } from 'vue';
import { Vue } from 'vue-property-decorator';

interface Range {
    min: number;
    max: number;
}

export default Vue.extend({
    name: 'RangeSlider',
    props: {
        value: {
            type: Object as PropType<Range>,
            default(): Range {
                return { min: undefined, max: undefined };
            },
        },
        filter: {
            type: Object as PropType<Filter>,
            required: true,
        },
        currencySymbol: {
            type: String,
            required: true,
        },
    },
    computed: {
        decimalPlaces(): number {
            const partsAroundDecimalDot = (this.filter.stepSize ?? 1).toString().split('.');

            return partsAroundDecimalDot.length > 1 ? partsAroundDecimalDot[1].length : 0;
        },
    },
    data() {
        return {
            currentRange: [] as number[],
        };
    },
    watch: {
        filter() {
            this.currentRange = [
                this.filter.selectedRange.min ?? this.filter.totalRange.min,
                this.filter.selectedRange.max ?? this.filter.totalRange.max,
            ];
        },
        value: {
            handler(newValue: Range) {
                this.currentRange = [
                    newValue.min ?? this.filter.selectedRange.min ?? this.filter.totalRange.min,
                    newValue.max ?? this.filter.selectedRange.max ?? this.filter.totalRange.max,
                ];
            },
            immediate: true,
        },
    },
    methods: {
        onRangeSliderChange([min, max]: [min: number, max: number]): void {
            this.currentRange = [min, max];
            this.$emit('input', { min, max });
        },
        formatNumber(n: number): string {
            return Number(n).toFixed(this.decimalPlaces);
        },
    },
});
</script>

<style lang="scss">
.slider-input input {
    max-width: 7ch !important;
}
</style>
